import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';

var SubHeader = function SubHeader(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_jsx("div", {
    id: "subHeader",
    children: /*#__PURE__*/_jsx("div", {
      className: "subHeaderWrapper",
      children: /*#__PURE__*/_jsx("div", {
        className: "subHeaderContent",
        children: children
      })
    })
  });
};

export default SubHeader;